import { render, staticRenderFns } from "./MaterialIndex.vue?vue&type=template&id=21b9cfee&scoped=true&"
import script from "./MaterialIndex.vue?vue&type=script&lang=ts&"
export * from "./MaterialIndex.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialIndex.vue?vue&type=style&index=0&id=21b9cfee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9cfee",
  null
  
)

export default component.exports